import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";
import { translations } from "@/i18n/translations";
import { CheckCircle, Home } from "lucide-react";
import { trackPageView, trackEvent } from "@/utils/analytics";

const ThankYou = () => {
  const { language } = useLanguage();
  const t = translations[language].thankYou;
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname);
    trackEvent("contact_form_submit", { send_to: "AW-18252346676" });
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Helmet>
        {/* Event snippet for Offerte aanvragen conversion page */}
        <script>{`
          (function() {
            var granted = false;
            try { granted = localStorage.getItem('analytics_consent') === 'granted'; } catch (e) {}
            if (!granted || typeof gtag !== 'function') return;
            gtag('event', 'conversion', {'send_to': 'AW-18252346676/x3leCOWSteYcELTqsv9D'});
          })();
        `}</script>
      </Helmet>

      <Navigation />

      <main className="flex-grow flex items-center justify-center px-4 py-20">
        <div className="max-w-xl w-full text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 text-primary mb-6">
            <CheckCircle className="w-8 h-8" />
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight mb-4">
            {t.title}
          </h1>

          <p className="text-base sm:text-lg text-muted-foreground mb-8 leading-relaxed">
            {t.description}
          </p>

          <Button
            asChild
            size="lg"
            className="bg-primary text-primary-foreground font-semibold hover:bg-primary/90 transition-colors"
          >
            <Link to="/">
              <Home className="w-4 h-4 mr-2" />
              {t.backToHome}
            </Link>
          </Button>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ThankYou;
